// extracted by mini-css-extract-plugin
module.exports = {"card":"testimony-card_card__Vk12x","flag":"testimony-card_flag__bLrfb"};